/* ===================================================================
   ENNAKOIVA HAKU  →  assets/predictive-search.js
   Shopifyn /search/suggest.json. Tuotteet + kokoelmat.
   Avautuu header-napista, debounce, Esc/overlay sulkee, fokuslukko.
   =================================================================== */
(function () {
  'use strict';

  var panel = document.querySelector('[data-search-panel]');
  if (!panel) return;

  var input = panel.querySelector('[data-search-input]');
  var results = panel.querySelector('[data-search-results]');
  var form = panel.querySelector('[data-search-form]');
  var openers = document.querySelectorAll('[data-search-open]');
  var closers = panel.querySelectorAll('[data-search-close]');

  var money = window.themeMoneyFormat || '${{amount}}';
  // Käännökset + kielijuuri (layout/theme.liquid → window.themeStrings / themeRoot)
  var S = window.themeStrings || {};
  var ROOT = window.themeRoot || '/';
  function tq(key, fb, q) { return (S[key] || fb).replace('__Q__', q); }
  var lastQuery = '';
  var debounceTimer = null;
  var controller = null;
  var lastFocused = null;

  // ---- Rahamuoto (kaikki Shopify money_format -placeholderit) ----
  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents, 10) || 0;

    function thousands(num, sep) {
      return num.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    }

    var value = (cents / 100).toFixed(2);        // esim "129.90"
    var intPart = value.split('.')[0];
    var decPart = value.split('.')[1];

    // muodot:  piste/pilkku tuhaterottimena, pilkku/piste desimaalierottimena
    var withComma      = thousands(intPart, ',') + '.' + decPart; // 1,234.56
    var withCommaSep   = thousands(intPart, '.') + ',' + decPart; // 1.234,56
    var withPeriodSep  = thousands(intPart, ' ') + ',' + decPart; // 1 234,56 (space-erotin)
    var noDecComma     = thousands(intPart, ',');                 // 1,234
    var noDecPeriod    = thousands(intPart, '.');                 // 1.234
    var noDecSpace     = thousands(intPart, '\u00a0');            // 1 234

    return money
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecPeriod)
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, noDecSpace)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, withCommaSep)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, withPeriodSep)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, thousands(intPart, "'") + '.' + decPart)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecComma)
      .replace(/\{\{\s*amount\s*\}\}/g, withComma);
  }

  // ---- Hinnan tulkinta suggest-API:n eri muodoista ----
  function renderPrice(raw) {
    if (raw === null || typeof raw === 'undefined') return '';

    if (typeof raw === 'number') {
      // Shopify antaa yleensä sentit kokonaislukuna
      return formatMoney(raw);
    }

    if (typeof raw === 'string') {
      var s = raw.trim();
      if (s === '') return '';
      // Jos sisältää valuuttasymbolin/kirjaimia → jo muotoiltu, käytä sellaisenaan
      if (/[^\d.,\s]/.test(s)) return s;
      // Muuten pelkkä luku, esim "2629.95" (euroina) tai "2629" → sentteinä formatMoneylle
      var num = parseFloat(s.replace(',', '.'));
      if (isNaN(num)) return s;
      return formatMoney(Math.round(num * 100));
    }

    return '';
  }

  // ---- Scroll-fade indikaattori bodyyn ----
  var body = panel.querySelector('.search-modal__body');
  function updateFade() {
    if (!body) return;
    var scrollTop = body.scrollTop;
    var maxScroll = body.scrollHeight - body.clientHeight;
    body.removeAttribute('data-at-top');
    body.removeAttribute('data-at-bottom');
    body.removeAttribute('data-no-scroll');
    if (maxScroll <= 2) { body.setAttribute('data-no-scroll', ''); return; }
    if (scrollTop <= 2) body.setAttribute('data-at-top', '');
    else if (scrollTop >= maxScroll - 2) body.setAttribute('data-at-bottom', '');
  }
  if (body) body.addEventListener('scroll', updateFade, { passive: true });

  function openPanel() {
    lastFocused = document.activeElement;
    panel.hidden = false;
    // pakota reflow ennen luokkaa (transition)
    void panel.offsetWidth;
    panel.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    setTimeout(function () { input.focus(); }, 60);
    document.addEventListener('keydown', onKeydown);
    updateFade();
  }

  function closePanel() {
    panel.classList.remove('is-open');
    panel.classList.remove('has-query');
    input.value = '';
    results.innerHTML = '';
    lastQuery = '';
    document.body.style.overflow = '';
    openers.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    document.removeEventListener('keydown', onKeydown);
    var done = function () {
      panel.hidden = true;
      panel.removeEventListener('transitionend', done);
    };
    panel.addEventListener('transitionend', done);
    // varmuus jos reduced-motion (ei transitionia)
    setTimeout(function () { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 350);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }

  function onKeydown(e) {
    if (e.key === 'Escape') { e.preventDefault(); closePanel(); }
  }

  openers.forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openPanel(); });
  });
  closers.forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); closePanel(); });
  });

  // ---- Haku ----
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // Palauta turvallinen href/src: salli vain suhteelliset polut ja http(s).
  // Estä javascript:, data:, vbscript: yms. ja escapoi HTML-attribuuttiin.
  function safeUrl(raw) {
    var s = String(raw == null ? '' : raw).trim();
    if (s === '') return '';
    // torju kontrollimerkit (mm. \t\n\r joilla skeeman voi piilottaa)
    var stripped = s.replace(/[\u0000-\u001F\u007F]/g, '').toLowerCase();
    if (/^(javascript|data|vbscript|file):/.test(stripped)) return '';
    return escapeHtml(s);
  }

  function render(data, query) {
    var products = (data.resources && data.resources.results && data.resources.results.products) || [];
    var collections = (data.resources && data.resources.results && data.resources.results.collections) || [];

    if (!products.length && !collections.length) {
      results.innerHTML = '<p class="psearch__empty">' + escapeHtml(tq('noResultsFor', 'Ei tuloksia haulla \u201c__Q__\u201d', query)) + '</p>';
      return;
    }

    var html = '';

    var searchUrl = form.getAttribute('action') + '?q=' + encodeURIComponent(query) + '&type=product,collection';
    html += '<a class="psearch__all psearch__all--top" href="' + searchUrl + '">' +
      '<span>' + escapeHtml(tq('viewAllFor', 'Näytä kaikki tulokset haulle \u201c__Q__\u201d', query)) + '</span>' +
      '<span class="psearch__all-arrow" aria-hidden="true">→</span></a>';

    if (collections.length) {
      html += '<div class="psearch__group"><p class="psearch__group-title">' + escapeHtml(S.collections || 'Osastot') + '</p><ul class="psearch__collections">';
      collections.forEach(function (c) {
        html += '<li><a class="psearch__collection" href="' + safeUrl(c.url) + '">' + escapeHtml(c.title) + '</a></li>';
      });
      html += '</ul></div>';
    }

    if (products.length) {
      html += '<div class="psearch__group"><p class="psearch__group-title">' + escapeHtml(S.products || 'Tuotteet') + '</p><ul class="psearch__products">';
      products.forEach(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        var priceHtml = '';
        var raw = (typeof p.price !== 'undefined' && p.price !== null) ? p.price : p.price_min;
        var priceStr = renderPrice(raw);
        if (priceStr) {
          priceHtml = '<div class="psearch__pcard-price">' + escapeHtml(priceStr) + '</div>';
        }
        html += '<li><a class="psearch__pcard" href="' + safeUrl(p.url) + '">' +
          '<div class="psearch__pcard-img">' + (img ? '<img src="' + safeUrl(img) + '&width=300" alt="' + escapeHtml(p.title) + '" loading="lazy" width="300" height="300">' : '') + '</div>' +
          '<div class="psearch__pcard-name">' + escapeHtml(p.title) + '</div>' + priceHtml +
          '</a></li>';
      });
      html += '</ul></div>';
    }

    results.innerHTML = html;
    updateFade();
  }

  function doSearch(query) {
    if (controller) controller.abort();
    controller = ('AbortController' in window) ? new AbortController() : null;

    results.innerHTML = '<p class="psearch__loading">' + escapeHtml(S.searching || 'Haetaan…') + '</p>';

    var url = ROOT + 'search/suggest.json?q=' + encodeURIComponent(query) +
      '&resources[type]=product,collection' +
      '&resources[limit]=8' +
      '&resources[options][unavailable_products]=last';

    fetch(url, controller ? { signal: controller.signal } : {})
      .then(function (r) { return r.json(); })
      .then(function (data) { render(data, query); })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        results.innerHTML = '';
      });
  }

  input.addEventListener('input', function () {
    var q = input.value.trim();
    if (debounceTimer) clearTimeout(debounceTimer);
    if (q.length < 2) {
      results.innerHTML = '';
      lastQuery = '';
      panel.classList.remove('has-query');
      return;
    }
    panel.classList.add('has-query');
    if (q === lastQuery) return;
    lastQuery = q;
    debounceTimer = setTimeout(function () { doSearch(q); }, 220);
  });

  // Enter → siirry täydelle hakusivulle (form submit hoituu natiivisti)
})();